export default __webpack_public_path__ + "static/media/toledo_5.0ad633ca.png";